import { Injectable } from '@angular/core';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IInspectionJob } from '../interfaces/inspections/inspection-job';
import { InspectionDeploymentStatus } from '../enums/inspection-deployment-status.enum';

@Injectable({
  providedIn: 'root',
})
export class InspectionDeploymentService extends BaseDataService {
  public url = '/api/inspectionDeployment';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getInspectionDeploymentStatus(): Promise<InspectionDeploymentStatus> {
    return this.http.get<InspectionDeploymentStatus>(`${this.url}/deploymentStatus`).toPromise();
  }

  public getInspectionSiteJobs(): Promise<IInspectionJob[]> {
    return this.http.get<IInspectionJob[]>(`${this.url}/undeployed`).toPromise();
  }

  public deployInspectionJobs() {
    return this.http.post<any>(`${this.url}/deploy`, null).toPromise();
  }
}
